import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';


// function get(name) {
//   return ContentStorage.get(ComponentKeys.GENERAL, name);
// }

function getValue(name) {
  return ContentStorage.getValue(ComponentKeys.GENERAL, name);
}


class GeneralComponent {
  static get priceRangeSeparator() {
    return getValue('PriceRangeSeparator');
  }
}


export default GeneralComponent;
